import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
// import { GetQuotesApiParameter } from "@insite/client-framework/Services/QuoteService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { GetQuotesApiParameter } from "@MasterBluePrint/Services/CustomQuoteService";
// import loadQuotes from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuotes";
import loadQuotes from "@MasterBluePrint/Store/Data/Quote/Handlers/LoadQuote";
// import { getQuotesDataView } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import updateSearchFields from "@insite/client-framework/Store/Pages/RfqMyQuotes/Handlers/UpdateSearchFields";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Page from "@insite/mobius/Page";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getQuotesDataView } from "@MasterBluePrint/Store/Data/Quote/QuoteSelector";
import qs from "qs";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    quotesDataView: getQuotesDataView(state, state.pages.rfqMyQuotes.getQuotesParameter),
    getQuotesParameter: state.pages.rfqMyQuotes.getQuotesParameter,
    location: getLocation(state),
});

const mapDispatchToProps = {
    loadQuotes,
    updateSearchFields,
};
export interface RfqQuotePageStyles {
    loadFailedWrapper?: InjectableCss;
    loadFailedText?: TypographyPresentationProps;
    quickLinksGridItem?: GridItemProps;
    mainSectionGridItem?: GridItemProps;
}

export const rfqQuotePagetyles: RfqQuotePageStyles = {
    loadFailedWrapper: {
        css: css`
            display: flex;
            height: 200px;
            justify-content: center;
            align-items: center;
            background-color: ${getColor("common.accent")};
        `,
    },
    loadFailedText: { weight: "bold" },
    quickLinksGridItem: {
        width: [12, 12, 12, 2, 2],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        null,
                        css`
                            background: #fff;
                            padding-left: 0;
                            padding-right: 0;
                            box-shadow: 2px 0 4px 0 rgba(0,37,84,0.05);
                        `,
                        css`
                            max-width: 17rem;
                            flex-basis: 17rem;
                        `,
                        null,
                    ],
                    "min",
                )
            };
            @media screen and (max-width: 1279px) {
                max-width: 100% !important;
                flex-basis: 100% !important;
                background: transparent !important;
                box-shadow: none !important; 
            }
            @media screen and (min-width: 990px) and (max-width: 1199px) {
                max-width: 100%;
                flex-basis: 100%;
            }
            @media screen and (min-width: 990px) and (max-width: 1279px) {
                padding-bottom: 0;
            }
            @media print {
                display: none !important;;
            }
        `,
    },
    mainSectionGridItem: {
        width: [12, 12, 12, 10, 10],
        css: css`
            position: relative;
            &.quote-detail-content {
                > div {
                    position: relative;

                    > div:first-child {
                        > div > div > div {
                            h1[data-test-selector="PageTitle"] {
                                @media print {
                                    margin-bottom: 1rem;
                                    
                                    &:after {
                                        display: none;
                                    }
                                }
                                @media print and (orientation: landscape){
                                    margin-bottom: 0.5rem;
                                }
                            }
                        }
                        
                        > div {
                            > div:last-child {
                                > div:first-child {
                                    max-width: 61%;                                    
                                }
                            }
                        }
                    }
                    > div:nth-child(2) {
                        > div {
                            > div:first-child {
                                > div {
                                    > div:first-child {
                                        @media print and (orientation: portrait){
                                            display: none;
                                        }
                                        @media print and (orientation: landscape){
                                            display: none;
                                        }
                                    }
                                    > div {
                                        > div {
                                            > div {
                                                > div {
                                                    > div:first-child {
                                                        border-bottom: 1px solid #C2D1D9;
                                                        padding-top: 15px;
                                                        margin-bottom: 1.25rem;

                                                        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                                                            text-align: left;

                                                                            > div {
                                                                                > div[class^='GridItemStyle'], div[class*='GridItemStyle'] {
                                                                                    @media print {
                                                                                        padding-top: 0 !important;
                                                                                    }
                                                                                    &:first-child {
                                                                                        padding-top: 1.25rem;
                                                                                    }
                                                                                    &:last-child {
                                                                                        padding-bottom: 1.25rem;
                                                                                    }
                                                                                    > div {
                                                                                        > div {
                                                                                            padding-bottom: 0;
                                                                                            @media print {
                                                                                                padding-bottom: 0.3125rem;
                                                                                            }
                                                                                            
                                                                                            h3[class^='TypographyStyle'],
                                                                                            h3[class*='TypographyStyle'],
                                                                                            span[class^='TypographyStyle'],
                                                                                            span[class*='TypographyStyle']{
                                                                                                margin-bottom: 0;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        `,
                    ],
                    "max",
                )}

                                                        
                                                    }
                                                    > div:nth-child(2) {
                                                        margin-bottom: 0.75rem;
                                                        > div {
                                                            > div:first-child {
                                                                > div {
                                                                    background: #FFFFFF;
                                                                    padding: 0.9375rem 1.5625rem 1.5625rem;
                                                                }                                                                

                                                                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                                                                            margin-right: 0.9375rem;
                                                                            max-width: 43%; 
                                                                        `,
                    ],
                    "min",
                )}                                                
                                                                                                                            
                                                            }
                                                            > div:nth-child(2) {
                                                                padding: 0.9375rem 0.2rem 0.4688rem .5625rem;
                                                                                                                              
                                                                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                                                            padding-top: 1.25rem;
                                                                            max-width: 50%;
                                                                        `,
                    ],
                    "max",
                )}

                                                            }
                                                            > div:last-child {
                                                                padding: 0.9375rem 0.8rem 0.4688rem 1.125rem;

                                                                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                                                            padding-top: 1.25rem;
                                                                            max-width: 50%;
                                                                        `,
                    ],
                    "max",
                )}
                                                            }
                                                        }
                                                    }
                                                    > div:last-child {
                                                        padding: 0.625rem;
                                                        border-radius: 2px;
                                                        background-color: #F0F2F3;
                                                    }

                                                }
                                            }

                                        }
                                    }
                                }
                                @media print {
                                    width: 100%;
                                    max-width: 100%;
                                }
                            }
                            
                            > div:last-child {
                                > div {
                                    background: #fff;
                                    padding: 20px;
                                    box-shadow: 0 2px 4px 4px rgba(0,0,0,0.03);
	                                border-radius: 2px;
                                }
                                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                            // position: absolute;
                                            // bottom: 0;
                                        `,
                    ],
                    "max",
                )}
                                @media print {
                                    width: 50%;
                                    max-width: 50%;
                                }
                            }
                        }
                    }
                }
            }
            
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        null,
                        null,
                        css`
                            max-width: calc(100% - 17.5rem);
                            flex-basis: calc(100% - 17.5rem);
                            padding-left: 1.5625rem;
                        `,
                        null,
                    ],
                    "min",
                )
            };
            @media print {
                max-width: 100%;
                width: 100%
            }
            @media screen and (min-width: 990px) and (max-width: 1199px) {
                max-width: 100%;
                flex-basis: 100%;
            }
            @media screen and (max-width: 1279px) {
                max-width: 100% !important;
                flex-basis: 100% !important;

                .totalReorderbtnWrapper {
                    display: none;
                }
            }
        `,
    }
};


type Props = HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasShellContext &
    PageProps;

const RfqQuotePage = ({
    id,
    session,
    quotesDataView,
    getQuotesParameter,
    loadQuotes,
    updateSearchFields,
    history,
    location,
}: Props) => {
    let firstLoad = false;
    useEffect(() => {
        firstLoad = true;
        let parsedGetQuotesParameter: GetQuotesApiParameter = {};
        if (location.search) {
            parsedGetQuotesParameter = parseQueryString<GetQuotesApiParameter>(location.search);
            if (typeof parsedGetQuotesParameter.statuses === "string") {
                parsedGetQuotesParameter.statuses = [parsedGetQuotesParameter.statuses];
            }
        }

        updateSearchFields({
            ...getQuotesParameter,
            ...parsedGetQuotesParameter,
            expand: session.isSalesPerson ? ["salesList"] : undefined,
            type: "Replace",
        });
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            const queryString = qs.stringify(getQuotesParameter);
            history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }
    }, [getQuotesParameter]);

    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!firstLoad && !quotesDataView.value && !quotesDataView.isLoading) {
            loadQuotes(getQuotesParameter);
        }
    });
    const styles = rfqQuotePagetyles;
    return (
        <Page>

            <GridContainer>
                <GridItem {...styles.quickLinksGridItem}>
                    <Zone contentId={id} zoneName="NavigationList" />
                </GridItem>
                <GridItem {...styles.mainSectionGridItem} className="my-quote-content">
                    <Zone contentId={id} zoneName="Content" />
                </GridItem>
            </GridContainer>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withIsInShell(RfqQuotePage))),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RfqMyQuotePage" instead of this constant.
 */
export const RfqQuotePageContext = "RfqQuotePage";
